module.exports = __webpack_public_path__ + "static/media/macBook.bd2d20b1.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/macBook.gif
 ** module id = 640
 ** module chunks = 0
 **/